import request from '@/service/request'

export const getRechargeList = (category: any) => {
  return request<SERVICE.ResponsePage<HOME.RECHARGE[]>>({
    url: '/admin/recharge-config/page',
    method: 'GET',
    params: {
      page: 1,
      pageSize: 100,
      category: category
    }
  })
}

export const addRecharge = (data: HOME.RECHARGE) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/recharge-config',
    method: 'POST',
    data
  })
}

export const updateRecharge = (data: HOME.RECHARGE) => {
  return request<SERVICE.Response<string>>({
    url: '/admin/recharge-config',
    method: 'PUT',
    data
  })
}

export const delRechargeById = (id: string) => {
  return request<SERVICE.Response<string>>({
    url: `/admin/recharge-config/${id}`,
    method: 'DELETE'
  })
}

export const updateRechargeStatusById = (id: string, isEnabled: boolean) => {
  return request<SERVICE.Response<CODE.Detail[]>>({
    url: `/admin/recharge-config/${id}/status?isEnabled=${isEnabled}`,
    method: 'PUT'
  })
}
